var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiveHundered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 231.496,
    height: 231.496,
    viewBox: "0 0 231.496 231.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13806",
    "data-name": "Group 13806",
    transform: "translate(1.514 4.513)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_705",
    "data-name": "Ellipse 705",
    cx: 111.601,
    cy: 111.601,
    r: 111.601,
    transform: "translate(2.491 -0.224) rotate(-0.073)",
    fill: "rgba(158,166,65,0.2)",
    stroke: "#9ea641",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11196",
    "data-name": "Path 11196",
    d: "M40.728,128.054,75.471,93.311,40.728,58.568",
    transform: "translate(16.402 14.424)",
    fill: "none",
    stroke: "#9ea641",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11197",
    "data-name": "Path 11197",
    d: "M135.817,128.054,101.074,93.311l34.743-34.743",
    transform: "translate(41.053 14.424)",
    fill: "none",
    stroke: "#9ea641",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_660",
    "data-name": "Line 660",
    x2: 50.253,
    transform: "translate(91.874 161.478)",
    fill: "none",
    stroke: "#9ea641",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiveHundered);
export default __webpack_public_path__ + "static/media/FiveHundered.e8ec3af2cff77c8aea671fe96fc4b4a0.svg";
export { ForwardRef as ReactComponent };